import React, { useState } from "react";
import "./FAQ.css";
import { useTranslation } from "react-i18next";

const FAQ = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex((current) => (current === index ? null : index));
  };

  const faqs = t('agency.faqs', { returnObjects: true });

  return (
    <section id="faq" className="faq-section">
      <h2 className="faq-title">{t('agency.faqTitle')}</h2>
      <div className="faq-list">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <button
              type="button"
              className="faq-question"
              onClick={() => toggleAnswer(index)}
              aria-expanded={activeIndex === index}
              aria-controls={`faq-answer-${index}`}
            >
              <h3>{faq.question}</h3>
              <span className={`faq-toggle-icon ${activeIndex === index ? "active" : ""}`}>
                {activeIndex === index ? "▲" : "▼"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="faq-answer" id={`faq-answer-${index}`}>
                <p>{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
